import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="session-timeout-handler"
export default class extends Controller {
  connect() {
    document.addEventListener("turbo:before-fetch-response", this.handleFetchResponse);
  }

  disconnect() {
    document.removeEventListener("turbo:before-fetch-response", this.handleFetchResponse);
  }

  handleFetchResponse = (event) => {
    const response = event.detail.fetchResponse;

    if (response.response.status === 401 ||
        (response.response.redirected && response.response.url.includes("/users/sign_in"))) {
      event.preventDefault();
      window.location.href = "/users/sign_in";
    }
  }
}
